module.exports = __webpack_public_path__ + "img/31.2ae718c0.png";